import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ImportsComponent } from '@src/app/features/imports/imports/imports.component';
import { UploadDataComponent } from '@src/app/features/imports/upload-data/upload-data.component';

const routes: Routes = [
  { path: '', component: ImportsComponent },
  { path: 'upload-data', component: UploadDataComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ImportsRoutingModule { }
